import { IFavRequest } from "../types/types";
import { callApi } from "./api.service";

export const FavRequest = async (
  Data: IFavRequest
) => {
  const endpoint ="/api/public/favorites/favorite-request";
  return await callApi(endpoint, 'POST', false, undefined ,Data);
};